import { axios } from '@Root/API'

export const getEngagements = params => {
	return axios.get('student-engagement', { params })
}
